export default __webpack_public_path__ + "static/media/linfan.298b2df1.jpeg";